module.exports = __webpack_public_path__ + "img/task1.22c1c960.png";